import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PrimaryCta from 'bento-ordering/base/components/PrimaryCta';
import {
  isSubtotalBelowMinimumSelector,
  isDeliveryWithNoAddressSelector
} from 'bento-ordering/cart/selectors/';

const getCheckoutButtonLabel = (
  isDeliveryWithNoAddress,
  cartValidationError,
  cartValidationState
) => {
  if (isDeliveryWithNoAddress) {
    return 'Enter Address To Continue';
  } else if (
    cartValidationError &&
    cartValidationError ===
      'The cart has been idle and can no longer meet the fulfillment time.'
  ) {
    return 'Update Time To Continue';
  } else if (cartValidationError && /order minimum/.test(cartValidationError)) {
    return 'Add Items to Continue';
  } else if (cartValidationError && !cartValidationState.addressError) {
    return 'Remove Items To Continue';
  }
  return 'Checkout';
};

const CartPageCheckoutContainer = ({
  isDeliveryWithNoAddress,
  cartValidationError,
  isTotalBelowMinimum,
  isValidatingCartItemInventory,
  checkoutUrl,
  dataTestId,
  cartValidation
}) => {
  return (
    <PrimaryCta
      component="a"
      label={getCheckoutButtonLabel(
        isDeliveryWithNoAddress,
        cartValidationError,
        cartValidation
      )}
      href={checkoutUrl}
      fullWidth
      disabled={
        isTotalBelowMinimum ||
        isDeliveryWithNoAddress ||
        !!cartValidationError ||
        isValidatingCartItemInventory
      }
      dataTestId={dataTestId}
    />
  );
};

CartPageCheckoutContainer.propTypes = {
  isDeliveryWithNoAddress: PropTypes.bool,
  cartValidationError: PropTypes.string,
  isTotalBelowMinimum: PropTypes.bool,
  isValidatingCartItemInventory: PropTypes.bool,
  checkoutUrl: PropTypes.string,
  dataTestId: PropTypes.string,
  cartValidation: PropTypes.object
};

CartPageCheckoutContainer.defaultProps = {
  dataTestId: 'cart-checkout-button'
};

const mapStateToProps = state => {
  const { cart, cartValidation } = state;

  const isDeliveryWithNoAddress = isDeliveryWithNoAddressSelector(cart);
  const isTotalBelowMinimum = isSubtotalBelowMinimumSelector(cart);
  const {
    isValidatingCartItemInventory,
    checkout_url: checkoutUrl,
    cartValidationError
  } = cart;

  return {
    isDeliveryWithNoAddress,
    cartValidationError,
    isTotalBelowMinimum,
    isValidatingCartItemInventory,
    checkoutUrl,
    cartValidation
  };
};

export default connect(mapStateToProps)(CartPageCheckoutContainer);
